<h2 mat-dialog-title>{{ 'DOMAIN_STARTSCHERM.TEST_PROFILE.CHOOSE' | i18n }}</h2>

<mat-dialog-content style="height: 380px">
    <ag-grid-angular
        style="width: 100%; height: 100%"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        (rowClicked)="testProfileSelected($event.data)"
    >
    </ag-grid-angular>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton [mat-dialog-close]="false">{{ 'DOMAIN_STARTSCHERM.GENERAL.CANCEL' | i18n }}</button>
</mat-dialog-actions>
